import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { VarDirectiveModule } from '../../directives/ng-var';
import { TextHighlightPipeModule } from '../../pipes/text-highlight';
import { EntitySelectComponent } from './entity-select.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        VarDirectiveModule,
        TextHighlightPipeModule,
    ],
    exports: [EntitySelectComponent],
    declarations: [EntitySelectComponent],
    providers: [],
})
export class EntitySelectModule { }
